<div class="invite-friends" [appLoading]="loading">
  <div class="header">
    <span>{{ 'invi_f' | translate }}</span>
    <i class="icon-error" (click)="close()"></i>
  </div>
  <div class="content">
    <div class="image-wrap">
      <img src="assets/temp5/recommend-friend/invite-bg.png" alt="" />
      <div>
        <div class="invite-and">{{ 'refer_friend_get' | translate }}</div>
        <div *ngIf="!loading">
          <span class="money"
            >{{ currency?.isDigital ? '' : currency?.symbol
            }}{{ friendService.reward(referAFriendReward, rate) | currencyValue : currency?.currency || ''
            }}{{ currency?.isDigital ? currency?.symbol : '' }}</span
          >
          <span class="add">+</span>
          <span class="percent">25%</span>
        </div>
        <div class="commission">{{ 'get_commission' | translate }}</div>
        <div class="to-invite">{{ 'invite_friend_money' | translate }}</div>
      </div>
    </div>
    <div class="learn-more" [routerLink]="['/', appService.languageCode, 'referral', 'home']" (click)="close()">
      {{ 'learn_more' | translate }}
    </div>
    <div class="share-link" *ngIf="referralUrl">
      <div class="label">{{ 'share_your_link' | translate }}</div>
      <div class="your-link">
        <div class="text">{{ referralUrl }}</div>
        <app-tool-tip [copyMode]="'custom'" [copyContent]="referralUrl"
          ><div origin>{{ 'rp_h_cl' | translate }}</div></app-tool-tip
        >
      </div>
    </div>
  </div>
</div>
